import styles from "./styles.module.css";
import { noteTone } from "../../utils/review";

const Note = ({
  note,
  size = "medium",
}: {
  note: number;
  size?: "small" | "medium";
}) => {
  const reviewRate = noteTone(note);
  return (
    <div
      className={`${styles.note} ${styles[reviewRate]} ${styles[`size-${size}`]}`}
    >
      {note.toLocaleString()}
    </div>
  );
};

export default Note;
